import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Activity } from "lucide-react";

const MESSAGES = [
  "Analyzing your symptoms...",
  "Cross-referencing functional medicine markers...",
  "Assessing imaging red flags...",
  "Prioritizing labs vs specialty tests...",
  "Drafting your workup...",
];

export default function LoadingReport() {
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % MESSAGES.length), 2200);
    return () => clearInterval(t);
  }, []);

  return (
    <div
      data-testid="report-loading"
      className="max-w-3xl mx-auto px-6 py-16"
      aria-live="polite"
    >
      <div className="flex flex-col items-center text-center">
        <div className="relative flex h-16 w-16 items-center justify-center">
          <span className="absolute inline-flex h-full w-full rounded-full bg-brand-blue-light animate-ping opacity-70" />
          <span className="relative inline-flex h-12 w-12 items-center justify-center rounded-full bg-brand-blue text-white">
            <Activity className="h-6 w-6" strokeWidth={2.2} />
          </span>
        </div>
        <div className="mt-8 h-8 relative w-full">
          <AnimatePresence mode="wait">
            <motion.p
              key={idx}
              initial={{ opacity: 0, y: 6 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -6 }}
              transition={{ duration: 0.35 }}
              className="font-heading text-lg text-ink-900 absolute inset-0"
            >
              {MESSAGES[idx]}
            </motion.p>
          </AnimatePresence>
        </div>
        <p className="mt-2 text-sm text-ink-500">This usually takes about 10 seconds.</p>
      </div>

      <div className="mt-12 space-y-4">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="rounded-2xl border border-slate-100 bg-white p-6 shadow-sm">
            <div className="flex items-center gap-3">
              <div className="h-6 w-24 rounded-full bg-slate-100 animate-pulse" />
              <div className="h-6 w-16 rounded-full bg-slate-100 animate-pulse" />
            </div>
            <div className="mt-4 h-4 w-3/4 rounded bg-slate-100 animate-pulse" />
            <div className="mt-2 h-4 w-2/3 rounded bg-slate-100 animate-pulse" />
          </div>
        ))}
      </div>
    </div>
  );
}
